import { PrismicCheckoutConfiguration } from "prismic/PrismicModels"
import { useContext } from "react"
import { CheckoutConfigContext } from "./CheckoutConfigContext"

export const useCheckoutConfigContext = () => useContext(CheckoutConfigContext)

export const useCheckoutConfig = (): PrismicCheckoutConfiguration =>
  useCheckoutConfigContext().config || []
